import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props} from './types';

import {Clickable} from '../../../uikit/Clickable';
import * as S from './styles';

export const SwitchEnvButtonJSX: FC<Props> = ({
  env = 'core',
  hasUpdates,
  onClick,
  testID,
  variant,
}) => {
  const {t} = useI18n();

  return (
    <Clickable onClick={onClick} testID={testID}>
      <S.Container env={env} hasUpdates={hasUpdates} variant={variant}>
        <S.Text buttonVariant={variant} env={env}>
          {t('shared:switch_to')}
        </S.Text>
        <S.IconContainer>
          <S.Icon env={env} />
          {hasUpdates ? <S.UpdatesBadge env={env} /> : null}
        </S.IconContainer>
      </S.Container>
    </Clickable>
  );
};
